module.exports = __webpack_public_path__ + "static/media/ICN_Textil_small.fbcab56e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ICN_Textil_small.svg
// module id = 183
// module chunks = 0